/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountData } from './AccountData';
import {
    AccountDataFromJSON,
    AccountDataFromJSONTyped,
    AccountDataToJSON,
    AccountDataToJSONTyped,
} from './AccountData';

/**
 * 
 * @export
 * @interface AccountDataVersion
 */
export interface AccountDataVersion {
    /**
     * 
     * @type {AccountData}
     * @memberof AccountDataVersion
     */
    account: AccountData;
    /**
     * 
     * @type {Date}
     * @memberof AccountDataVersion
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {Set<string>}
     * @memberof AccountDataVersion
     */
    modifiedFields: Set<string>;
}

/**
 * Check if a given object implements the AccountDataVersion interface.
 */
export function instanceOfAccountDataVersion(value: object): value is AccountDataVersion {
    if (!('account' in value) || value['account'] === undefined) return false;
    if (!('modifiedFields' in value) || value['modifiedFields'] === undefined) return false;
    return true;
}

export function AccountDataVersionFromJSON(json: any): AccountDataVersion {
    return AccountDataVersionFromJSONTyped(json, false);
}

export function AccountDataVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDataVersion {
    if (json == null) {
        return json;
    }
    return {
        
        'account': AccountDataFromJSON(json['account']),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'modifiedFields': new Set(json['modifiedFields']),
    };
}

export function AccountDataVersionToJSON(json: any): AccountDataVersion {
    return AccountDataVersionToJSONTyped(json, false);
}

export function AccountDataVersionToJSONTyped(value?: AccountDataVersion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': AccountDataToJSON(value['account']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'modifiedFields': Array.from(value['modifiedFields'] as Set<any>),
    };
}

